import { render, staticRenderFns } from "./ImprintCityPriceBreakdown.vue?vue&type=template&id=5fe32513&scoped=true"
import script from "./ImprintCityPriceBreakdown.vue?vue&type=script&lang=js"
export * from "./ImprintCityPriceBreakdown.vue?vue&type=script&lang=js"
import style0 from "./ImprintCityPriceBreakdown.vue?vue&type=style&index=0&id=5fe32513&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe32513",
  null
  
)

export default component.exports